import { render, staticRenderFns } from "./BillingsTable.vue?vue&type=template&id=74ac5a19"
import script from "./BillingsTable.vue?vue&type=script&lang=js"
export * from "./BillingsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports